import { BlueprintInstanceType } from '../../shared.enums';
import { findSeamConnection } from '../helpers';

import type { PanelTrim } from '../panel-trim.class';

export const getPairedSeamTrimCfn = (panelTrim: PanelTrim): PanelTrim | null => {
	const { panels, refMap: { island }} = panelTrim;
	const [firstId, secondId] = panels;
	if (!island) return null;

	const first = island.panels.findById(firstId);
	const second = island.panels.findById(secondId);
	if (!first || !second) return null;

	const seam = findSeamConnection([first, second], island);
	if (!seam) return null;

	const { connectedPanel, connection } = seam;
	const { targetIsland, targetPanel } = connection;

	// findSeamConnection already filters out obstruction targets, but the type only narrows with an explicit check
	if (targetIsland?.instanceOf !== BlueprintInstanceType.Island || !targetPanel) return null;

	// facePanel is the trim's other panel (not the one carrying the connection) - same convention as get-flat-trim-dimensions.cfn.ts
	const facePanel = connectedPanel.id === first.id ? second : first;

	// the panel ring's left/right adjacency is reciprocal by construction (Panel.connectLeftSideToPanel/connectRightSideToPanel
	// always wire both sides), so whichever side carries the seam on facePanel also carries it on targetPanel -
	// this holds regardless of panel role (front/back/side) or the islands' relative world rotation
	const connectedPanelIsOnFacePanelRight = facePanel.connections.right?.targetPanelId === connectedPanel.id;
	const pairedFacePanel = connectedPanelIsOnFacePanelRight ? targetPanel.getRightPanel() : targetPanel.getLeftPanel();
	if (!pairedFacePanel) return null;

	return targetIsland.panelTrims.findByPanelIds(targetPanel.id, pairedFacePanel.id) ?? null;
};
